module.exports = __webpack_public_path__ + "static/media/modem.8778ee61.svg";